"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _locales = _interopRequireDefault(require("@site/spins/locales"));
var _locales2 = _interopRequireDefault(require("@site/price-block/locales"));
var _spins = require("@site/spins");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _headlineLockup = require("@site/pattern-library-core/headline-lockup");
var _spinner = _interopRequireDefault(require("../../../elements/other/spinner"));
var _config = require("./config");
var _resultButtons = require("./result-buttons");
var _siteSearchContext = require("../site-search-context");
var _searchBanner = _interopRequireDefault(require("../search-banner"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Local Imports
*/

const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-cctd2tf"
});
const SerpContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SerpContainer",
  class: "pl-s1kfkycq"
});
const ExactContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ExactContainer",
  class: "pl-e1ley2hg"
});
const BelowExact = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "BelowExact",
  class: "pl-b1jwo7wc"
});

/**
 * SerpSpin Component.
 * A Component that renders the SERP results for the domain search.
 *
 * @param {string} searchValue The query string used for the domain search.
 * @param {string} apiKey The API key used for authentication.
 * @param {string} plid A plid with 1 as GoDaddy everything > 0 being a reseller
 * @param {string} env The environment setting (e.g., 'prod' for production).
 * @param {string} market The market setting for local results (e.g., 'en-US' for English, United States).
 * @param {String} isc ISC code for discounts.
 * @param {String} itc ITC to inject for tracking purposes.
 * @param {String} suggestionHeadline The headline to display above the results.
 * @param {Object} exactButtonProps The props for the exact match button.
 * @param {Object} spinButtonProps The props for the spin buttons.
 * @returns {React.ReactElement} SerpSpin Component
 * @public
 */

// eslint-disable-next-line complexity
function SerpSpin() {
  const {
    searchValue,
    searchData,
    searchBanner,
    searchDataIsLoading,
    currentDomainSearch
  } = (0, _react.useContext)(_siteSearchContext.SiteSearchContext);
  const {
    exactResults,
    spinResults,
    error
  } = searchData[searchValue] || {};
  const {
    market,
    suggestionHeadline,
    exactButtonProps,
    spinButtonProps,
    maxSpins = 5,
    appName = 'fos_site_search',
    ...spinProps
  } = currentDomainSearch || {};
  const [mergedLanguage, setMergedLanguage] = (0, _react.useState)({});
  (0, _react.useEffect)(() => {
    let cancelled = false;
    async function loadLanguage() {
      const [spinLang, pricingLang] = await Promise.all([Promise.resolve((0, _locales.default)(market)), Promise.resolve((0, _locales2.default)(market))]);
      if (!cancelled) {
        setMergedLanguage({
          ...spinLang,
          ...pricingLang
        });
      }
    }
    if (market) loadLanguage();
    return () => {
      cancelled = true;
    };
  }, [market]);
  const isTaken = exactResults?.ExactMatchDomain?.AvailabilityLabel === 'taken';
  const isNotSupported = Object.values(_config.unavailableErrors).includes(exactResults?.ExactMatchDomain?.AvailabilityLabel);
  if (error) return searchBanner ? /*#__PURE__*/_react.default.createElement(_searchBanner.default, {
    dataCy: 'search-banner'
  }) : /*#__PURE__*/_react.default.createElement("div", null, "Error: ", error);
  const getExactSpinResults = () => {
    if (exactResults && exactResults.ExactMatchDomain && spinResults) {
      const isPremium = ['auction', 'registry_premium', 'premium'].includes(exactResults.ExactMatchDomain.AvailabilityLabel);
      const modifiedExactMatchDomain = {
        ...exactResults.ExactMatchDomain,
        IsExactMatch: !isPremium
      };

      // Create a new customized spinResults object with the exact match domain data
      const integratedSpins = {
        ...spinResults
      };
      integratedSpins.RecommendedDomains = [modifiedExactMatchDomain];
      if (Array.isArray(exactResults?.Products) && exactResults.Products.length > 0) {
        integratedSpins.Products = [exactResults.Products[0]];
      } else {
        integratedSpins.Products = [];
      }
      return integratedSpins;
    }
    return spinResults;
  };
  const exactSpinResults = getExactSpinResults();
  const {
    PremiumPhone: premiumPhone = '',
    AuctionPhone: auctionPhone = '',
    SupportPhone: supportPhone = ''
  } = searchData[searchValue]?.exactResults || {};
  return /*#__PURE__*/_react.default.createElement(Container, {
    "data-cy": "serp-container"
  }, suggestionHeadline && /*#__PURE__*/_react.default.createElement(_headlineLockup.HeadlineString, {
    heading: suggestionHeadline,
    headlineSize: "h5",
    headingDataCy: "suggestion-headline",
    headlineLineLength: 3
  }), /*#__PURE__*/_react.default.createElement(SerpContainer, {
    "data-cy": "search-serp"
  }, searchDataIsLoading && /*#__PURE__*/_react.default.createElement(_spinner.default, {
    size: "lg"
  }), !searchDataIsLoading && exactResults && !isNotSupported && !isTaken && /*#__PURE__*/_react.default.createElement(ExactContainer, {
    "data-cy": "exact-match-results"
  }, /*#__PURE__*/_react.default.createElement(_spins.SpinsModernTightened, (0, _extends2.default)({
    appName: appName,
    spinsResponse: exactSpinResults,
    options: {
      ..._config.exactMatchOptions,
      tagsAndInfo: {
        ..._config.exactMatchOptions.tagsAndInfo,
        premiumPhone,
        auctionPhone,
        supportPhone
      }
    },
    language: mergedLanguage,
    hideBottomPadding: true,
    AddToCartButton: () => /*#__PURE__*/_react.default.createElement(_resultButtons.ExactButton, {
      searchQuery: searchValue,
      exactButtonProps: exactButtonProps
    })
  }, spinProps))), !searchDataIsLoading && spinResults && /*#__PURE__*/_react.default.createElement(BelowExact, {
    "data-cy": "spin-results"
  }, /*#__PURE__*/_react.default.createElement(_spins.SpinsModernTightened, (0, _extends2.default)({
    appName: appName,
    spinsResponse: spinResults,
    options: {
      ..._config.spinsOptions,
      spinsPerPage: maxSpins,
      maxSpins: maxSpins,
      tagsAndInfo: {
        ..._config.spinsOptions.tagsAndInfo,
        premiumPhone,
        auctionPhone,
        supportPhone
      }
    },
    language: mergedLanguage,
    AddToCartButton: e => /*#__PURE__*/_react.default.createElement(_resultButtons.SpinButton, {
      domainEntry: e?.domain,
      spinButtonProps: spinButtonProps
    })
  }, spinProps)))));
}
var _default = exports.default = /*#__PURE__*/_react.default.memo(SerpSpin);